/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/24/ctrl-left': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M15.191 23.588l-8-11a1 1 0 010-1.176l8-11 1.617 1.176L9.236 12l7.572 10.412-1.617 1.176z" _fill="#272c33"/>'
  }
})
